import React from 'react'
import { useNavigate } from 'react-router-dom'

// Reusable back-arrow icon + click behavior, shared by CustomBackHeader's
// default icon and any page that needs the same arrow outside the header bar
// (e.g. a desktop hero that doesn't render CustomBackHeader at all).
const BackArrow = ({
    className = "",
    colorClass = "menu-head",
    sizeClass = "w-8 h-6",
    onClick,
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(-1);
        }
    };

    return (
        <button
            type="button"
            className={`text-xl ${colorClass} ${className}`}
            onClick={handleClick}
            aria-label="Go back"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className={sizeClass}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10 19l-7-7 7-7"
                />
                <line
                    x1="3"
                    y1="12"
                    x2="21"
                    y2="12"
                    stroke="currentColor"
                    strokeWidth="2"
                />
            </svg>
        </button>
    )
}

export default BackArrow
